import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UserRow from './UserRow';
import {
    sortingParamType, userPropertiesType,
    usersType,
} from '../../types';
import './_styles_/UsersList.css';
import SortControl from '../SortControl';

UsersList.propTypes = {
    users: usersType.isRequired,
    userProps: userPropertiesType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function UsersList(props) {
    const {
        users,
        userProps,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="users-list">
            <div className="rich-list-row rich-list-header users-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="user-header--values--user-id">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="racf">
                        {t('users.list-header.user-id')}
                    </SortControl>
                </div>
                <div className="user-header--values--name">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="name">
                        {t('users.list-header.name')}
                    </SortControl>
                </div>
                <div className="user-header--values--email">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="email">
                        {t('users.list-header.email')}
                    </SortControl>
                </div>
                <div className="user-header--values--last-login-time">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="lastSigninTime">
                        {t('users.list-header.last-login-time')}
                    </SortControl>
                </div>
                <div className="user-header--values--suspended">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="suspended">
                        {t('users.list-header.suspended')}
                    </SortControl>
                </div>
                <div className="user-header--values--active">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="active">
                        {t('users.list-header.active')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                users.length
                    ? users.map((user) => <UserRow user={user} userProps={userProps} key={user.id} />)
                    : (<div className="users-no-items">{t('users.no-items')}</div>)
            }
        </div>
    );
}

export default UsersList;
